module.exports = __webpack_public_path__ + "static/media/hawk.611a474f.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/hawk.png
// module id = 2581
// module chunks = 0